import { CircularProgress } from "@mui/material";

import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router";
import { developerSignUp } from "../../dev_services/developer/api";
import { ToastContainer, toast } from 'react-toastify'; // Import ToastContainer and toast
import 'react-toastify/dist/ReactToastify.css';
import "../../dev_pages/auth/dev_signup.scss";
import {devbglogo, devCheck} from "../../../assets"




const DeveloperSignup = () => {
  const navigate = useNavigate();
  const [isLoading, setLoading] = useState(false);
  const [formValues, setFormValues] = useState({
    first_name: '',
    last_name: '',
    email: '',
    partner_name: '',
    password: '',
    phone_number: '',
    confirmPassword: '',
  });

  useEffect(() => {
    // Do something with the updated values whenever they change
    console.log("Form values updated:", formValues);
  }, [formValues]);
  const [isTabletView, setIsTabletView] = useState<boolean>(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsTabletView(window.innerWidth <= 1024); // Example: Consider width <= 1024 as tablet view
    };

    // Call checkScreenSize once to determine initial view
    checkScreenSize();

    // Add event listener to check screen size on resize
    window.addEventListener('resize', checkScreenSize);

    // Clean up event listener on component unmount
    return () => {
      window.removeEventListener('resize', checkScreenSize);
    };
  }, []);
  const handleSignup = async (values) => {
    setLoading(true);
    try {
      const { confirmPassword, ...submitValues } = values;
      const response = await developerSignUp(submitValues);
      console.log(response.token);
      if (response.token !== null) {
     
        toast.success('SignUp Successfully');
        setTimeout(() => {
          navigate('/developer/login');
        }, 1000);
      } else {
        const errorMessage =
          (response && response.data && response.data.error) || 'Unknown error occurred';
        console.error('SignUp failed:', errorMessage);
        toast.error(errorMessage);
      }
    } catch (error: any) {
      console.error('Error:', error.message);
      toast.error(error.error);
    }
    finally {
      setLoading(false);
    }
  };
  return (
    <>
      <div className="hidden md:block bggSignUp-img ">
        {isTabletView ? (

          <div style={{ zIndex: 1 }} className="col-md-6 col-sm-12 order1 bggSignUp-img ">
            <div className="col-md-12 d-flex flex-column justify-content-start">
              <div className="text-center mt-lg-5 mt-md-4 mt-1">
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                  <a href="#">
                    <img src={devbglogo} alt="Image" width="200px" height="42px" className="block-center srrlogo mt-5 mt-lg-0" />
                  </a>
                </div>
              </div>
              <div style={{ borderRadius: "15px", paddingTop: "40px", padding: "40px", paddingLeft: "40px", paddingRight: "40px" }} className="bg-white">
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    handleSignup(formValues);
                  }}
                >
                  <h3 style={{ fontFamily: "sfprobold", fontSize: "20px" }} className="text-center fs-20px mt-2 mt-md-3 mb-4 font-weight-bold">
                    {"Sign Up To App Store Partner's Account"}
                  </h3>
                  {/* <div style={{ justifyContent: "center", gap: "20px" }} className="row d-none d-md-flex mt-15">
                    <div className="col-md-4 col-6 pr-sm">
                      <a className="btn btn-block btn-social btn-border">
                        <div className="img-container">
                          <img src={googleIcon} alt="Google" width="20px" height="20px" className="w-20px" />
                          <span style={{ fontFamily: "sfpromedium" }} className="text-right">Google</span>
                        </div>
                      </a>
                    </div>
                    <div className="col-md-4 col-6 pr-sm">
                      <a className="btn btn-block btn-social btn-border">
                        <div className="img-container">
                          <img src={phoneIcon} alt="Phone" width="20px" height="20px" className="w-20px" />
                          <span style={{ fontFamily: "sfpromedium" }}>Phone No</span>
                        </div>
                      </a>
                    </div>
                  </div> */}
                  {/* <div className="text-center pv">
                    <p style={{ fontFamily: "sfpromedium", fontSize: "16px" }} className="my-1 text-center fs-16px">
                      <span className="dashed-border mb-2px"></span>or <span className="dashed-border mb-2px"></span>
                    </p>
                  </div> */}
                  <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <div className="mb-3">
                      <label htmlFor="first_name" className="block">First Name</label>
                      <input
                        style={{ borderRadius: "5px", height: "36px", width: "100%", borderWidth: "1px", padding: "10px" }}
                        type="text"
                        id="first_name"
                        placeholder="Enter your First name"
                        name="first_name"
                        value={formValues.first_name}
                        onChange={(e) => setFormValues({ ...formValues, first_name: e.target.value })}
                        required
                      />
                    </div>
                    <div className="mb-3">
                      <label htmlFor="last_name" className="block">Last Name</label>
                      <input
                        style={{ borderRadius: "5px", height: "36px", width: "100%", borderWidth: "1px", padding: "10px" }}
                        type="text"
                        id="last_name"
                        placeholder="Enter your Last name"
                        name="last_name"
                        value={formValues.last_name}
                        onChange={(e) => setFormValues({ ...formValues, last_name: e.target.value })}
                        required
                      />
                    </div>
                  </div>
                  <div className="mb-3">
                    <label htmlFor="email" className="block">Email ID</label>
                    <input
                      style={{ borderRadius: "5px", height: "36px", width: "100%", borderWidth: "1px", padding: "10px" }}
                      type="email"
                      id="email"
                      placeholder="Enter your email"
                      name="email"
                      value={formValues.email}
                      onChange={(e) => setFormValues({ ...formValues, email: e.target.value })}
                      required
                    />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="phone_number" className="block">Phone</label>
                    <input
                      style={{ borderRadius: "5px", height: "36px", width: "100%", borderWidth: "1px", padding: "10px" }}
                      type="text"
                      id="phone_number"
                      placeholder="Enter your phone"
                      name="phone_number"
                      value={formValues.phone_number}
                      onChange={(e) => setFormValues({ ...formValues, phone_number: e.target.value })}
                      required
                    />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="partnername" className="block">Partner Name</label>
                    <input
                      style={{ borderRadius: "5px", height: "36px", width: "100%", borderWidth: "1px", padding: "10px" }}
                      type="text"
                      id="partnername"
                      placeholder="Enter your Partner Name"
                      name="partnername"
                      value={formValues.partner_name}
                      onChange={(e) => setFormValues({ ...formValues, partner_name: e.target.value })}
                      required
                    />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="password" className="block">Password</label>
                    <input
                      style={{ borderRadius: "5px", height: "36px", width: "100%", borderWidth: "1px", padding: "10px" }}
                      type="password"
                      placeholder="Enter your password"
                      id="password"
                      name="password"
                      value={formValues.password}
                      onChange={(e) => setFormValues({ ...formValues, password: e.target.value })}
                      required
                    />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="confirmPassword" className="block">Confirm Password</label>
                    <input
                      style={{ borderRadius: "5px", height: "36px", width: "100%", borderWidth: "1px", padding: "10px" }}
                      type="password"
                      placeholder="Enter your Confirm password"
                      id="confirmPassword"
                      name="confirmPassword"
                      value={formValues.confirmPassword}
                      onChange={(e) => setFormValues({ ...formValues, confirmPassword: e.target.value })}
                      required
                    />
                  </div>
                  {isLoading ? (
                    <div style={{ textAlign: "center" }}>
                      <CircularProgress color="inherit" size={24} />
                    </div>
                  ) : (
                    <button
                      style={{ fontFamily: "sfpromedium" }}
                      type="submit"
                      className="mt-lg-4 btn btn-bg-blue rounded-10px col-md-12 h-40px fs-14px text-light font-weight-bold mt-4 mt-lg-0"
                    >
                      Sign Up
                    </button>
                  )}
                  <div className="centered col-md-12 col-xs-12 font-14 mt-3" style={{ color: '#969696', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <span>Already have an account ?</span>
                    <button style={{ marginLeft: '7px', color: '#745BE7' }} onClick={() => navigate('/developer/login')} color="primary">
                      Login
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        ) : (
          <div className="min-h-screen h-100 pt-sm-4 position-relative bg-blueclr bggSignUp-img">
            <ToastContainer />
            <div className="pt-4 ps-4 pe-4 pb-md-4 position-relative">
              <div style={{ display: 'flex', paddingTop: "55px", justifyContent: "center" }}>
                <div className="col-md-6 col-sm-12 d-flex flex-column order2">
                  <div className="col-md-12 d-flex flex-column">
                    <div style={{ borderRadius: "15px", paddingLeft: "40px", paddingRight: "40px", width: "100%" }}>
                      <div>
                        <div>
                          <div style={{ display: 'flex', }}>
                            <a href="#">
                              <img src={devbglogo} alt="Image" width="300px" height="150px" className="block-center srrlogo mt-5 mt-lg-0" />
                            </a>
                          </div>
                          <div>
                            <label className="block srrlogo mt-5 mt-lg-0" style={{ color: "white", height: "130px", width: "600px", textAlign: "left", fontFamily: "sfprobold", fontSize: "42px" }}>
                              {"Integrate your app and Drive more revenue "}
                            </label>
                          </div>
                          <div>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                              <div>
                                <a href="#">
                                  <img src={devCheck} alt="Image" width="25px" height="25px" className="block-center srrlogo mt-5 mt-lg-0" />
                                </a>
                              </div>
                              <label className="block srrlogo mt-5 mt-lg-0" style={{ color: "white", textAlign: "left", fontFamily: "sfproregular", fontSize: "22px", marginLeft: "10px" }}>
                                {"Expand Userbase"}
                              </label>
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                              <div>
                                <a href="#">
                                  <img src={devCheck} alt="Image" width="25px" height="25px" className="block-center srrlogo mt-5 mt-lg-0" />
                                </a>
                              </div>
                              <label className="block srrlogo mt-5 mt-lg-0" style={{ color: "white", textAlign: "left", fontFamily: "sfproregular", fontSize: "22px", marginLeft: "10px" }}>
                                {"Streamline the Journey"}
                              </label>
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                              <div>
                                <a href="#">
                                  <img src={devCheck} alt="Image" width="25px" height="25px" className="block-center srrlogo mt-5 mt-lg-0" />
                                </a>
                              </div>
                              <label className="block srrlogo mt-5 mt-lg-0" style={{ color: "white", textAlign: "left", fontFamily: "sfproregular", fontSize: "22px", marginLeft: "10px" }}>
                                {"Earn with Ease"}
                              </label>
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                              <div>
                                <a href="#">
                                  <img src={devCheck} alt="Image" width="25px" height="25px" className="block-center srrlogo mt-5 mt-lg-0" />
                                </a>
                              </div>
                              <label className="block srrlogo mt-5 mt-lg-0" style={{ color: "white", textAlign: "left", fontFamily: "sfproregular", fontSize: "22px", marginLeft: "10px" }}>
                                {"Grow through Co-marketing"}
                              </label>
                            </div>


                          </div>
                        </div>
                      </div>
                      <form onSubmit={(e) => { e.preventDefault(); /* handleSubmit(formValues); */ }}>
                        <h3 style={{ fontFamily: "sfprobold", fontSize: "40px", lineHeight: "2.8rem" }} className="fs-20px mt-2 mt-md-3 mb-4">
                          {/* {"We Are More than Just a Shipping Partner"} */}
                        </h3>
                      </form>
                    </div>
                  </div>
                </div>
                <div style={{ zIndex: 1 }} className="col-md-6 col-sm-12 order1">
                  <div className="col-md-12 d-flex flex-column justify-content-start">
                    <div style={{ borderRadius: "15px", paddingTop: "40px", padding: "40px", paddingLeft: "40px", paddingRight: "40px" }} className="bg-white">
                      <form
                        onSubmit={(e) => {
                          e.preventDefault();
                          handleSignup(formValues);
                        }}
                      >
                        <h3 style={{ fontFamily: "sfprobold", fontSize: "20px" }} className="text-center fs-20px mt-2 mt-md-3 mb-4 font-weight-bold">
                          {"Sign Up To App Store Partner's Account"}
                        </h3>
                        {/* <div style={{ justifyContent: "center", gap: "20px" }} className="row d-none d-md-flex mt-15">
                          <div className="col-md-4 col-6 pr-sm">
                            <a className="btn btn-block btn-social btn-border">
                              <div className="img-container">
                                <img src={googleIcon} alt="Google" width="20px" height="20px" className="w-20px" />
                                <span style={{ fontFamily: "sfpromedium" }} className="text-right">Google</span>
                              </div>
                            </a>
                          </div>
                          <div className="col-md-4 col-6 pr-sm">
                            <a className="btn btn-block btn-social btn-border">
                              <div className="img-container">
                                <img src={phoneIcon} alt="Phone" width="20px" height="20px" className="w-20px" />
                                <span style={{ fontFamily: "sfpromedium" }}>Phone No</span>
                              </div>
                            </a>
                          </div>
                        </div>
                        <div className="text-center pv">
                          <p style={{ fontFamily: "sfpromedium", fontSize: "16px" }} className="my-1 text-center fs-16px">
                            <span className="dashed-border mb-2px"></span>or <span className="dashed-border mb-2px"></span>
                          </p>
                        </div> */}
                        <div style={{ display: "flex", justifyContent: "space-between" }}>
                          <div className="mb-3">
                            <label htmlFor="first_name" className="block">First Name</label>
                            <input
                              style={{ borderRadius: "5px", height: "36px", width: "100%", borderWidth: "1px", padding: "10px" }}
                              type="text"
                              id="first_name"
                              placeholder="Enter your First name"
                              name="first_name"
                              value={formValues.first_name}
                              onChange={(e) => setFormValues({ ...formValues, first_name: e.target.value })}
                              required
                            />
                          </div>
                          <div className="mb-3">
                            <label htmlFor="last_name" className="block">Last Name</label>
                            <input
                              style={{ borderRadius: "5px", height: "36px", width: "100%", borderWidth: "1px", padding: "10px" }}
                              type="text"
                              id="last_name"
                              placeholder="Enter your Last name"
                              name="last_name"
                              value={formValues.last_name}
                              onChange={(e) => setFormValues({ ...formValues, last_name: e.target.value })}
                              required
                            />
                          </div>
                        </div>
                        <div className="mb-3">
                          <label htmlFor="email" className="block">Email ID</label>
                          <input
                            style={{ borderRadius: "5px", height: "36px", width: "100%", borderWidth: "1px", padding: "10px" }}
                            type="email"
                            id="email"
                            placeholder="Enter your email"
                            name="email"
                            value={formValues.email}
                            onChange={(e) => setFormValues({ ...formValues, email: e.target.value })}
                            required
                          />
                        </div>
                        <div className="mb-3">
                          <label htmlFor="phone_number" className="block">Phone</label>
                          <input
                            style={{ borderRadius: "5px", height: "36px", width: "100%", borderWidth: "1px", padding: "10px" }}
                            type="text"
                            id="phone_number"
                            placeholder="Enter your phone"
                            name="phone_number"
                            value={formValues.phone_number}
                            onChange={(e) => setFormValues({ ...formValues, phone_number: e.target.value })}
                            required
                          />
                        </div>
                        <div className="mb-3">
                          <label htmlFor="partnername" className="block">Partner Name</label>
                          <input
                            style={{ borderRadius: "5px", height: "36px", width: "100%", borderWidth: "1px", padding: "10px" }}
                            type="text"
                            id="partnername"
                            placeholder="Enter your Partner Name"
                            name="partnername"
                            value={formValues.partner_name}
                            onChange={(e) => setFormValues({ ...formValues, partner_name: e.target.value })}
                            required
                          />
                        </div>
                        <div className="mb-3">
                          <label htmlFor="password" className="block">Password</label>
                          <input
                            style={{ borderRadius: "5px", height: "36px", width: "100%", borderWidth: "1px", padding: "10px" }}
                            type="password"
                            placeholder="Enter your password"
                            id="password"
                            name="password"
                            value={formValues.password}
                            onChange={(e) => setFormValues({ ...formValues, password: e.target.value })}
                            required
                          />
                        </div>
                        <div className="mb-3">
                          <label htmlFor="confirmPassword" className="block">Confirm Password</label>
                          <input
                            style={{ borderRadius: "5px", height: "36px", width: "100%", borderWidth: "1px", padding: "10px" }}
                            type="password"
                            placeholder="Enter your Confirm password"
                            id="confirmPassword"
                            name="confirmPassword"
                            value={formValues.confirmPassword}
                            onChange={(e) => setFormValues({ ...formValues, confirmPassword: e.target.value })}
                            required
                          />
                        </div>
                        {isLoading ? (
                          <div style={{ textAlign: "center" }}>
                            <CircularProgress color="inherit" size={24} />
                          </div>
                        ) : (
                          <button
                            style={{ fontFamily: "sfpromedium" }}
                            type="submit"
                            className="mt-lg-4 btn btn-bg-blue rounded-10px col-md-12 h-40px fs-14px text-light font-weight-bold mt-4 mt-lg-0"
                          >
                            Sign Up
                          </button>
                        )}
                        <div className="centered col-md-12 col-xs-12 font-14 mt-3" style={{ color: '#969696', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                          <span>Already have an account ?</span>
                          <button style={{ marginLeft: '7px', color: '#745BE7' }} onClick={() => navigate('/developer/login')} color="primary">
                            Login
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        )}
      </div>
      <div className="block md:hidden bggSignUp-img">
        <div style={{ zIndex: 1 }} className="col-md-6 col-sm-12 order1">
          <div className="col-md-12 d-flex flex-column justify-content-start">
            <div className="text-center mt-lg-5 mt-md-4 mt-1">
              <div style={{ display: 'flex', justifyContent: 'center' }}>
                <a href="#">
                  <img src={devbglogo} alt="Image" width="150px" height="42px" className="block-center srrlogo mt-5 mt-lg-0" />
                </a>
              </div>
            </div>
            <div style={{ borderRadius: "15px", paddingTop: "40px", padding: "40px", paddingLeft: "40px", paddingRight: "40px" }} className="bg-white">
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  handleSignup(formValues);
                }}
              >
                <h3 style={{ fontFamily: "sfprobold", fontSize: "20px" }} className="text-center fs-20px mt-2 mt-md-3 mb-4 font-weight-bold">
                  {"Sign Up To App Store Partner's Account"}
                </h3>
                {/* <div style={{ justifyContent: "center", gap: "20px" }} className="row d-none d-md-flex mt-15">
                  <div className="col-md-4 col-6 pr-sm">
                    <a className="btn btn-block btn-social btn-border">
                      <div className="img-container">
                        <img src={googleIcon} alt="Google" width="20px" height="20px" className="w-20px" />
                        <span style={{ fontFamily: "sfpromedium" }} className="text-right">Google</span>
                      </div>
                    </a>
                  </div>
                  <div className="col-md-4 col-6 pr-sm">
                    <a className="btn btn-block btn-social btn-border">
                      <div className="img-container">
                        <img src={phoneIcon} alt="Phone" width="20px" height="20px" className="w-20px" />
                        <span style={{ fontFamily: "sfpromedium" }}>Phone No</span>
                      </div>
                    </a>
                  </div>
                </div>
                <div className="text-center pv">
                  <p style={{ fontFamily: "sfpromedium", fontSize: "16px" }} className="my-1 text-center fs-16px">
                    <span className="dashed-border mb-2px"></span>or <span className="dashed-border mb-2px"></span>
                  </p>
                </div> */}
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                  <div className="mb-3">
                    <label htmlFor="first_name" className="block">First Name</label>
                    <input
                      style={{ borderRadius: "5px", height: "36px", width: "100%", borderWidth: "1px", padding: "10px" }}
                      type="text"
                      id="first_name"
                      placeholder="Enter your First name"
                      name="first_name"
                      value={formValues.first_name}
                      onChange={(e) => setFormValues({ ...formValues, first_name: e.target.value })}
                      required
                    />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="last_name" className="block">Last Name</label>
                    <input
                      style={{ borderRadius: "5px", height: "36px", width: "100%", borderWidth: "1px", padding: "10px" }}
                      type="text"
                      id="last_name"
                      placeholder="Enter your Last name"
                      name="last_name"
                      value={formValues.last_name}
                      onChange={(e) => setFormValues({ ...formValues, last_name: e.target.value })}
                      required
                    />
                  </div>
                </div>
                <div className="mb-3">
                  <label htmlFor="email" className="block">Email ID</label>
                  <input
                    style={{ borderRadius: "5px", height: "36px", width: "100%", borderWidth: "1px", padding: "10px" }}
                    type="email"
                    id="email"
                    placeholder="Enter your email"
                    name="email"
                    value={formValues.email}
                    onChange={(e) => setFormValues({ ...formValues, email: e.target.value })}
                    required
                  />
                </div>
                <div className="mb-3">
                  <label htmlFor="phone_number" className="block">Phone</label>
                  <input
                    style={{ borderRadius: "5px", height: "36px", width: "100%", borderWidth: "1px", padding: "10px" }}
                    type="text"
                    id="phone_number"
                    placeholder="Enter your phone"
                    name="phone_number"
                    value={formValues.phone_number}
                    onChange={(e) => setFormValues({ ...formValues, phone_number: e.target.value })}
                    required
                  />
                </div>
                <div className="mb-3">
                  <label htmlFor="partnername" className="block">Partner Name</label>
                  <input
                    style={{ borderRadius: "5px", height: "36px", width: "100%", borderWidth: "1px", padding: "10px" }}
                    type="text"
                    id="partnername"
                    placeholder="Enter your Partner Name"
                    name="partnername"
                    value={formValues.partner_name}
                    onChange={(e) => setFormValues({ ...formValues, partner_name: e.target.value })}
                    required
                  />
                </div>
                <div className="mb-3">
                  <label htmlFor="password" className="block">Password</label>
                  <input
                    style={{ borderRadius: "5px", height: "36px", width: "100%", borderWidth: "1px", padding: "10px" }}
                    type="password"
                    placeholder="Enter your password"
                    id="password"
                    name="password"
                    value={formValues.password}
                    onChange={(e) => setFormValues({ ...formValues, password: e.target.value })}
                    required
                  />
                </div>
                <div className="mb-3">
                  <label htmlFor="confirmPassword" className="block">Confirm Password</label>
                  <input
                    style={{ borderRadius: "5px", height: "36px", width: "100%", borderWidth: "1px", padding: "10px" }}
                    type="password"
                    placeholder="Enter your Confirm password"
                    id="confirmPassword"
                    name="confirmPassword"
                    value={formValues.confirmPassword}
                    onChange={(e) => setFormValues({ ...formValues, confirmPassword: e.target.value })}
                    required
                  />
                </div>
                {isLoading ? (
                  <div style={{ textAlign: "center" }}>
                    <CircularProgress color="inherit" size={24} />
                  </div>
                ) : (
                  <button
                    style={{ fontFamily: "sfpromedium" }}
                    type="submit"
                    className="mt-lg-4 btn btn-bg-blue rounded-10px col-md-12 h-40px fs-14px text-light font-weight-bold mt-4 mt-lg-0"
                  >
                    Sign Up
                  </button>
                )}
                <div className="centered col-md-12 col-xs-12 font-14 mt-3" style={{ color: '#969696', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <span>Already have an account ?</span>
                  <button style={{ marginLeft: '7px', color: '#745BE7' }} onClick={() => navigate('/developer/login')} color="primary">
                    Login
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );


};

export default DeveloperSignup;